import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ToastMessageOptions } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { AgilityButtonComponent } from '@agility-components/agility-button/agility-button.component';
import { UserNotificationService } from '@services/user-notification/user-notification.service';

@Component({
  selector: 'app-agility-toast',
  imports: [ToastModule, AgilityButtonComponent],
  templateUrl: './agility-toast.component.html',
  styles: `
    .agility-toast {
      &__title {
        font-family: var(--lexend-semi-bold);
        font-size: var(--text-l);
      }
      &__copy-button {
        min-width: 24px;
        min-height: 24px;
      }
      &__icon {
        font-size: 2rem;
      }
      &__summary {
        margin: 0 0 0.5rem;
      }
      &__lines {
        list-style: none;
        margin: 0;
        padding: 0;
      }
      &__line {
        display: flex;
        align-items: center;
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgilityToastComponent {
  private readonly userNotificationService = inject(UserNotificationService);

  onAction(message: ToastMessageOptions, actionId: string): void {
    if (message.id) {
      this.userNotificationService.dispatchToastAction(message.id, actionId);
    }
  }
}
